import { installObjectHasOwnCompat } from './bootstrap/objectHasOwn'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'

installObjectHasOwnCompat()

const rootElement = document.getElementById('root')

if (rootElement === null) {
  throw new Error('Root element #root not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
